<template>
  <div>
	  <el-dialog
	  title="选择位置"
	  :visible.sync="open"
	  width="50%"
	  :before-close="dialogClose"> 
	  <div class="icon-content w-100 dialog-50 " >
	  <iframe  width="100%" height="100%" frameborder=0 src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=AIXBZ-UK3WJ-MOYFM-KZOEZ-74WKO-YCFAQ&referer=fangc">
	         </iframe>
			 </div>
			 <span slot="footer" class="dialog-footer">
			   <el-button @click="open=false">关闭</el-button>
			 </span>
	  </el-dialog>
	   <el-form-item :required="required" :label="label">
	     <el-input    v-model="address"  >
	        <el-button  type="primary" slot="append" @click="open=true" icon="el-icon-search"></el-button>
	      </el-input>
	    </el-form-item>
  </div>
</template>
<script>
  export default {
	            props: {
	                 'value':String,
					  label:{
					  					  type: String,
					  					  default: "位置"
					  },
					  required: {
					  	type: Boolean,
					  	default:true
					  },
	            },
    data() {
      return {
		  address:'',
		  	  open:false,
			  addressx:''
      }
    },
	
    methods: {
		dialogClose(){
			this.open=false;
		},
		returnAddressx(){
			return this.addressx;
		}
	},
	watch: {
	  
	    		 value(newval){
	    				   this.address=newval;
	    		 }
	    	   },
	 mounted() {
	            var self = this;
	            window.addEventListener('message', function(event) {
	                // 对于无法识别的地址，直接返回无法选择
	                if (event.data.poiname === '我的位置' || event.data.poiaddress === '') {
	                   	self.$message('无法识别该地址,请移动地图重新选择','warning');
						return;
	                }
	                if (event.data && event.data.module === 'locationPicker') { // 防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
					self.open=false;
					self.address=event.data.poiaddress;
					self.addressx=event.data;
	                 self.$emit('input', event.data.poiaddress);
						console.log(event.data.latlng.lat.toString()+','+event.data.latlng.lng.toString())
					if(typeof self.$parent.model.salt=='string')		self.$parent.model.extf=event.data.latlng.lat.toString()+','+event.data.latlng.lng.toString()
	                }
	            }, false)
	        }
  }
</script>
